import { combineReducers } from 'redux';
import { arcadeReducer } from './sections/arcade/reducer';
import { roomsReducer } from './sections/rooms/reducer';
import { cabinetsReducer } from './sections/cabinets/reducer';

export const arcadeSharedReducers = combineReducers({
    arcade: arcadeReducer,
    rooms: roomsReducer,
    cabinets: cabinetsReducer
});
